import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Home from './components/home';
import AboutUs from './components/about';
import Products from './components/products';
import Applications from './components/applications';
import ContactUs from './components/contact';
import FAQs from './components/faqs';
import { FaAngleUp, FaMessage  } from "react-icons/fa6";

function App() {
  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Router>
      <div>
        <Navbar />
        <div className="mt-[110px]">
          <Home />
          <AboutUs />
          <Products />
          <Applications />
          <FAQs />
          <ContactUs />
        </div>
        <Footer />

        {/* Floating Buttons */}
        <div className="fixed bottom-8 right-8 flex flex-col space-y-3">
          {/* Home Button */}
          <button
            onClick={() => scrollToSection('home')}
            className="p-3 bg-[#30779b] text-white rounded-full shadow-lg hover:bg-[#1c5a7a] transition-all"
            title="Go to Home"
          >
            <FaAngleUp  />
          </button>
          
          {/* Contact Us Button */}
          <button
            onClick={() => scrollToSection('contact-us')}
            className="p-3 bg-[#83b825] text-white rounded-full shadow-lg hover:bg-[#6ca81d] transition-all"
            title="Contact Us"
          >
            <FaMessage />
          </button>
        </div>
      </div>
    </Router>
  );
}

export default App;
